module.exports = __webpack_public_path__ + "img/McD_Unternehmen_Content_images_03.ea64ffa3.jpg";